/* template */
<template minapp="mpx" xlang="wxml"><div class="train-order-information-occupying" v-if="(!hasSeat)"><template v-for="(item, index) in (order.tickets_info)"><div class="item"><div class="left"><div class="name">{{ item.passenger_name }}</div><div class="state-card"><div class="card" v-if="(item.ticket_type)">{{ getType(item) }}</div></div></div><div class="seat">{{ item.seat_type }} {{price(item)}}</div></div><div class="line" v-if="(index!= order.tickets_info.length-1)"></div></template></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m61b33835"}'>
@import '~@/mixins/stylus/color.styl'

.train-order-information-occupying
  position relative
  display flex
  flex-direction column
  align-items center
  background #d2e6ff
  padding-top 25px
  margin-top -25px
  border-radius 10px
.item
  display flex
  height 42px
  width 100%
  padding 14px 16px
  justify-content space-between
  box-sizing border-box
  flex-direction row
  .left
    display flex
  .name
    font-family PingFang SC
    font-weight 500
    font-size 15px
    line-height 15px
    letter-spacing 0px
    color #222
  .seat
    font-family PingFang SC
    font-size 15px
    font-weight 500
    line-height 15px
    text-align right
    letter-spacing 0px
    color #222
.line
  width 327px
  height 0.5px
  background #ADCAEE
.state-card
  display flex
  align-items center
  .card
    position relative
    box-sizing border-box
    padding 2px
    margin-left 4px
    border-radius 3px
    font-family PingFangSC-Regular
    font-size 10px
    line-height 10px
    color #5F88C8
    &:after
      position absolute
      content ''
      width 200%
      height 200%
      box-sizing border-box
      border 1px solid #5F88C8
      transform-origin 0 0
      transform scale(0.5)
      border-radius 6px
      top 0
      left 0
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m61b33835"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index.mpx.js?isComponent&outputPath=components%2Findex61b33835%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Findex61b33835%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m61b33835"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/index61b33835/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
